"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _classnames = _interopRequireDefault(require("classnames"));
var _react = _interopRequireDefault(require("react"));
var _Modal = _interopRequireDefault(require("@mulesoft/anypoint-components/raw/components/Modal"));
var _ModalHeader = _interopRequireDefault(require("@mulesoft/anypoint-components/raw/components/ModalHeader"));
var _ModalBody = _interopRequireDefault(require("@mulesoft/anypoint-components/raw/components/ModalBody"));
var _ModalFooter = _interopRequireDefault(require("@mulesoft/anypoint-components/raw/components/ModalFooter"));
var _Button = _interopRequireDefault(require("@mulesoft/anypoint-components/raw/components/Button"));
var styles = {
  "modal": "modal_2sfuGE",
  "header": "header_2HK4oy",
  "body": "body_37a_tt",
  "footer": "footer_3e-xXL",
  "title": "title_2wMYZO"
}; 
require('./ConfirmModal.css');
var ConfirmModal = function ConfirmModal(_ref) {
  var _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className,
    title = _ref.title,
    body = _ref.body,
    _ref$cancelButtonText = _ref.cancelButtonText,
    cancelButtonText = _ref$cancelButtonText === void 0 ? 'Cancel' : _ref$cancelButtonText,
    _ref$confirmButtonTex = _ref.confirmButtonText,
    confirmButtonText = _ref$confirmButtonTex === void 0 ? 'Confirm' : _ref$confirmButtonTex,
    _ref$footer = _ref.footer,
    footer = _ref$footer === void 0 ? null : _ref$footer,
    _ref$isDanger = _ref.isDanger,
    isDanger = _ref$isDanger === void 0 ? false : _ref$isDanger,
    _ref$isLoading = _ref.isLoading,
    isLoading = _ref$isLoading === void 0 ? false : _ref$isLoading,
    onCancel = _ref.onCancel,
    onConfirm = _ref.onConfirm,
    _ref$testId = _ref.testId,
    testId = _ref$testId === void 0 ? 'confirm-modal' : _ref$testId,
    _ref$isConfirmDisable = _ref.isConfirmDisabled,
    isConfirmDisabled = _ref$isConfirmDisable === void 0 ? false : _ref$isConfirmDisable;
  var labelId = 'confirm-modal-title';
  return /*#__PURE__*/_react.default.createElement(_Modal.default, {
    renderInBody: false,
    testId: testId,
    onEsc: onCancel,
    onClickOverlay: onCancel,
    className: (0, _classnames.default)(styles.modal, className),
    labelId: labelId,
    role: isDanger ? 'alertdialog' : 'dialog',
    ariaLabelledBy: labelId
  }, /*#__PURE__*/_react.default.createElement(_ModalHeader.default, {
    testId: "confirm-modal-header",
    className: styles.header,
    isDanger: isDanger
  }, /*#__PURE__*/_react.default.createElement("h2", {
    id: labelId,
    className: styles.title
  }, title)), /*#__PURE__*/_react.default.createElement(_ModalBody.default, {
    testId: "confirm-modal-body",
    className: styles.body
  }, /*#__PURE__*/_react.default.createElement("div", {
    id: "".concat(labelId, "-label")
  }, body)), /*#__PURE__*/_react.default.createElement(_ModalFooter.default, {
    testId: "confirm-modal-footer",
    className: styles.footer
  }, /*#__PURE__*/_react.default.createElement(_Button.default, {
    testId: "confirm-modal-cancel-button",
    kind: "tertiary",
    onClick: onCancel,
    disabled: isLoading,
    noFill: true
  }, cancelButtonText), /*#__PURE__*/_react.default.createElement(_Button.default, {
    testId: "confirm-modal-confirm-button",
    kind: isDanger ? 'danger' : 'primary',
    onClick: onConfirm,
    disabled: isLoading || isConfirmDisabled,
    isLoading: isLoading
  }, confirmButtonText), footer));
};
var _default = exports.default = ConfirmModal;
//# sourceMappingURL=ConfirmModal.js.map